// components/UploadFile.jsx
import React, { useContext, useState } from "react";
import { useApi } from "../../hooks/useApi";
import { AuthContext } from './../../context/AuthContext';

const UploadFile = ({ uploadUrl, onCancel, onUploaded, cadenas = [] }) => {
  const { post } = useApi();
  const { user } = useContext(AuthContext);

  const [file, setFile] = useState(null);
  const [cadena, setCadena] = useState(cadenas[0] || "");
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    if (selected.size > 5 * 1024 * 1024) {
      setMessage("El archivo no puede superar los 5 MB.");
      setFile(null);
      return;
    }

    setFile(selected);
    setMessage(`Archivo listo para procesar: ${selected.name}`);
    setProgress(0);
  };

  const handleUpload = async () => {
    if (!file) return setMessage("Selecciona un archivo primero.");

    setUploading(true);
    setMessage("Subiendo archivo a Azure...");
    setProgress(0);

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("Usuario", user.username);
      if (cadenas.length > 0) formData.append("CadenaId", cadena);
      const response = await post(uploadUrl, formData, {
        onUploadProgress: (event) => {
          const percent = Math.round((event.loaded * 100) / event.total);
          setProgress(percent);
        },
      });

      setMessage(` Archivo subido. URL: ${response.url}`);
      setFile(null);
      setProgress(100);

      if (onUploaded) onUploaded();
    } catch (err) {
      console.error(err);
      setMessage(" Error al subir archivo.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-4 bg-white w-full">
      <div className="grid grid-cols-2 gap-4 mb-4 items-start">
        {cadenas.length > 0 && (
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Cadena:
            </label>
            <select
              value={cadena}
              onChange={(e) => setCadena(e.target.value)}
              className="border border-gray-300 rounded-md p-2 w-full"
            >
              <option value="">--Selecciona--</option>
              {cadenas.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.procesoNombre}
                </option>
              ))}
            </select>
          </div>
        )}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Archivo:
          </label>
          <input type="file" onChange={handleFileChange} className="w-full" />
          {file && (
            <p className="text-sm text-gray-600 mt-1">
              📄 {file.name} ({(file.size / 1024).toFixed(2)} KB)
            </p>
          )}
        </div>
      </div>

      {/* Botones centrados */}
      <div className="flex justify-left gap-4 mb-2">
        <button
          onClick={handleUpload}
          disabled={uploading || !file}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {uploading ? "Subiendo..." : "Enviar a proceso"}
        </button>
        {onCancel && (
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
          >
            Cancelar
          </button>
        )}
      </div>

      {/* Barra de progreso */}
      {progress > 0 && (
        <div className="h-2 w-full bg-gray-200 rounded mb-2">
          <div
            className="h-2 bg-blue-600 rounded"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      )}

      {/* Mensaje */}
      {message && <p className="text-center text-sm text-gray-700">{message}</p>}
    </div>
  );
};

export default UploadFile;
